import { dabkeLevels } from "../../data/content";
import useFormSubmit from "../../hooks/useFormSubmit";
import useReveal from "../../hooks/useReveal";
import { Field, SelectField, TextareaField } from "../ui/Field";
import FormStatus from "../ui/FormStatus";
import SectionTitle from "../ui/SectionTitle";

export default function JoinUs() {
  const { status, errors, submit } = useFormSubmit();
  const formRef = useReveal();

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(e.target);
  };

  return (
    <section id="rejoignez-nous" className="scroll-mt-20 bg-surface py-20 sm:py-28">
      <div className="container grid gap-14 lg:grid-cols-2">
        <div>
          <SectionTitle eyebrow="Rejoignez-nous" title="Formulaire de candidature à la troupe" />
          <p className="text-lg text-stone-200">
            La troupe Sham Dabke est ouverte aux danseuses et danseurs motivés, avec ou sans expérience
            professionnelle, mais ayant un vrai intérêt pour la dabké et le patrimoine levantin.
            Remplissez le formulaire ci-contre en nous expliquant votre parcours.
          </p>
        </div>

        <div ref={formRef} className="reveal">
          <FormStatus
            status={status}
            errors={errors}
            successMessage="Votre candidature a bien été envoyée, nous reviendrons vers vous rapidement."
          />
          <form onSubmit={handleSubmit} noValidate>
            <input type="hidden" name="form_type" value="rejoindre" />
            <div className="grid gap-4 sm:grid-cols-2">
              <Field id="join-nom" name="name" label="Nom complet" required />
              <Field id="join-email" name="email" type="email" label="Email" required />
              <Field id="join-phone" name="phone" type="tel" label="Téléphone" />
              <Field id="join-profession" name="profession" label="Profession / activité" />
              <SelectField
                id="join-niveau"
                name="niveau_dabke"
                label="Niveau en dabké"
                options={dabkeLevels}
                className="sm:col-span-2"
              />
              <TextareaField
                id="join-message"
                name="message"
                label="Message / motivation (en quelques lignes)"
                className="sm:col-span-2"
              />
            </div>
            <button type="submit" disabled={status === "submitting"} className="btn-primary mt-6 w-full disabled:opacity-60">
              {status === "submitting" ? "Envoi en cours…" : "Envoyer ma candidature"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
